import * as Sentry from "@sentry/gatsby"
import {
  isStaging,
  isPreviewDeck,
  isLocal,
  isProduction,
  sentryDsnCustomerWebProduction,
  RELEASE_NAME,
  ENABLE_SENTRY_NOISE_FILTER
} from "lib/environment"
import { filterOutKnownNoise } from "logging/features/filterOutKnownNoise"

const environment = () => {
  if (isStaging() || isPreviewDeck()) {
    return `development`
  }
  if (isProduction()) {
    return `production`
  }
  if (isLocal()) {
    return `localhost`
  }
  return undefined
}

const config = {
  dsn:
    isStaging() || isPreviewDeck() || isProduction()
      ? sentryDsnCustomerWebProduction
      : null,
  environment: environment(),
  release: RELEASE_NAME,
  integrations: [
    Sentry.browserTracingIntegration(),
    ...(ENABLE_SENTRY_NOISE_FILTER
      ? [
          Sentry.thirdPartyErrorFilterIntegration({
            filterKeys: [`customer-web`],
            behaviour: `drop-error-if-exclusively-contains-third-party-frames`
          })
        ]
      : [])
  ],
  tracesSampleRate: isProduction() ? 0.01 : 0,
  beforeSend(event) {
    if (ENABLE_SENTRY_NOISE_FILTER) {
      return filterOutKnownNoise(event, window?.navigator?.userAgent ?? ``)
    }

    if (window) {
      const isFacebookBrowser =
        window?.navigator && navigator?.userAgent?.includes?.(`FBAN`)

      const isInstagramBrowser =
        window?.navigator &&
        window?.navigator?.userAgent?.includes?.(`Instagram`)

      const isHeadlessChromeBrowser =
        window?.navigator && navigator?.userAgent?.includes?.(`HeadlessChrome`)

      if (isFacebookBrowser) return null
      if (isInstagramBrowser) return null
      if (isHeadlessChromeBrowser) return null
    }

    const title = event?.exception?.values?.[0]?.value || ``

    const stacktrace = event?.exception?.values?.[0]?.stacktrace?.frames || []

    const isOriginClarity =
      stacktrace.find(
        frame =>
          frame.abs_path?.includes(`clarity`) ||
          frame.abs_path?.includes(`afterpay`) ||
          frame.filename?.includes(`clarity`) ||
          frame.filename?.includes(`afterpay`)
      ) !== undefined

    const isOriginPayPal =
      stacktrace.find(frame => frame.filename?.includes(`paypal`)) !== undefined

    if (isOriginPayPal) {
      return null
    }

    if (
      title.startsWith(
        `Error: Failed to load https://www.googletagmanager.com/gtag/js?id=`
      )
    ) {
      return null
    }

    if (
      title.match(/We couldn't load "\/(.*?)\/page-data\/sq\/d\/(.*?)\.json"/)
    ) {
      return null
    }

    if (title.match(/Failed to fetch/i)) {
      return null
    }

    if (
      title.match(
        /This is a mock error for Sentry that should be blocked no.2/i
      )
    ) {
      return null
    }

    if (title.match(/Loading chunk [A-Za-z0-9]+ failed\./i)) {
      return null
    }

    if (isOriginClarity) {
      return null
    }

    return event
  }
}

export default config
